import ListColumnModel from 'modules/base/model/list-column-model'
import formatAmount from '@/modules/_helpers/formatAmount'
import { formatCurrency } from '@/modules/_helpers/formatCurrency'
import lang from '@/lang'
import { ArticleKinds } from '@/modules/base/util/constants'

export default class ArticleListColumnModel extends ListColumnModel {
  constructor(data) {
    super(data)
    this.displayed = data.displayed
    this.setColumnSpecificProperties()
  }

  setColumnSpecificProperties() {
    switch (this.name) {
      case 'totalSales':
        this.aggFunc = 'sum'
        this.setNumberType({ inRangeInclusive: true })

      // es-lint-disable: no-fallthrough
      case 'priceGross':
      case 'priceNet':
      case 'purchasePrice':
      case 'purchasePriceGross':
      case 'purchasePriceNet':
      case 'laborShare':
      case 'laborShareGross':
      case 'price': {
        this.cellRenderer = 'currencyAmountCellRenderer'
        this.filter = 'agNumberColumnFilter'
        this.filterParams = {
          inRangeInclusive: true,
        }
        this.getQuickFilterText = (params) => {
          return formatCurrency(params.value)
        }
        break
      }

      case 'stockAmount':
        this.setNumberType()
        this.getQuickFilterText = params => {
          return formatAmount(params.value)
        }
      // es-lint-disable: no-fallthrough
      case 'vatPercent': {
        this._reversed = true
        this.cellRenderer = 'amountCellRenderer'
        this.setNumberType()
        break
      }

      case 'createdAt': {
        this.setDateType()
        break
      }

      case 'category': {
        this.setFilterParam({ isOptional: true })
        break
      }

      case 'number': {
        this.cellRenderer = 'previewCell'
        this.setTextType()
        break
      }

      case 'description': {
        this.setTextType({ isOptional: true })
        this.valueGetter = params => {
          return params.data?.description
        }
        this.cellRenderer = 'htmlCellRenderer'
        break
      }

      case 'kind': {
        this.filter = 'agSetColumnFilter'
        this.filterParams = {
          values: Object.values(ArticleKinds),
          valueFormatter: (params) => {
            return lang.article.kinds[params.value] ?? params.value
          },
        }
        this.valueFormatter = (params) => {
          return lang.article.kinds[params.value]
        }
        break
      }

      default: { return }
    }
  }
}
